import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; // Importación actualizada
import { Router } from '@angular/router';
import { DialogData } from 'src/app/pages/encuesta/contestar/contestar.component';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    standalone: false
})
export class MessageBoxComponent {
  constructor(
    private _router: Router,
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  cerrar() {
    if (this.data.href != null) {
      this._router.navigate([this.data.href]);
    }
  }
}
